import type { ComputedRef, InjectionKey, Ref } from 'vue';
import { ILoader, INotification } from './interfaces/common';
import { Providers } from '@/utils/plugins/di/types';
import { IDeliveryPlugin } from '@/utils/plugins/delivery/types';
import { IMenuService } from '@/services/menu';
import { ComponentPublicInstance } from 'vue';
import { Config, Meta } from './interfaces/config';
import type { AgeRestrictionPayload } from '@/composables/analytics/use-age-restriction-analytics';

const NotificationKey: InjectionKey<
	ComponentPublicInstance<unknown, INotification>
> = Symbol('$notification');

const ProvidersKey: InjectionKey<Providers> = Symbol('providers');
const LoaderKey: InjectionKey<ComponentPublicInstance<unknown, ILoader>> =
	Symbol('$loader');

const DeliveryKey: InjectionKey<IDeliveryPlugin> = Symbol('delivery');
const MenuServiceKey: InjectionKey<IMenuService> = Symbol('menu-service');
const ThousandsSeparatorKey: InjectionKey<(value: number) => string> = Symbol(
	'$thousandsSeparator'
);
const ConfigKey = Symbol('$config') as InjectionKey<Config>;
const MetaKey = Symbol('$meta') as InjectionKey<Ref<Meta>>;
const CurrencyKey = Symbol('$currency') as InjectionKey<ComputedRef<string>>;

const AgeRestrictionKey: InjectionKey<{
	validate: (analytics: AgeRestrictionPayload) => Promise<boolean>;
}> = Symbol('$ageRestriction');

export {
	NotificationKey,
	ProvidersKey,
	LoaderKey,
	DeliveryKey,
	MenuServiceKey,
	ThousandsSeparatorKey,
	ConfigKey,
	MetaKey,
	CurrencyKey,
	AgeRestrictionKey
};
